export default __webpack_public_path__ + "static/media/videography2.44c851d5.jpg";